import { palette } from '@livable/saas-react-components';
const MuiInputAdornment = {
  styleOverrides: {
    root: {
      marginRight: '7px',
      path: {
        // fill: palette.shades[500],
      }
    },
    positionStart: {
      '& .MuiTypography-root': {
        color: palette.shades[800],
        fontSize: '18px'
      }
    }
  },
  variants: [{
    props: {
      type: 'infoTooltip'
    },
    style: {
      '.MuiSvgIcon-root path': {
        fill: palette.info.main
      },
      '.MuiIconButton-root': {
        marginRight: '0',
        padding: '0'
      }
    }
  }]
};
export default MuiInputAdornment;